import React from "react";
import PageHero from "../components/PageHero";
import SEO from "../components/SEO";
import { assets } from "../data/siteData";

export default function WaterAtmPage() {
  return (
    <>
      <SEO
        title="Water ATM Kiosks in Kolkata, Newtown, Rajarhat | Smart Public Water Dispensing"
        description="Hydrotec Solutions installs smart Water ATM kiosks in Kolkata, Newtown, Rajarhat, and across West Bengal. Affordable safe drinking water dispensing for communities, campuses, stations, and public spaces."
        keywords="water ATM Kolkata, water kiosk Newtown, public water dispenser Rajarhat, drinking water ATM West Bengal, water vending machine Kolkata, affordable water Kolkata"
        canonical="https://hydroteclimited.com/solutions/water-atm"
      />
      <PageHero
        title="Water ATM Solutions"
        text="Smart refill water kiosks for communities, institutions, public places, and commercial deployments."
        image={assets.waterAtmCity}
      />

      <section className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-2">
          <div>
            <h2 className="text-3xl font-bold text-slate-900">
              Smart, scalable, and impact-driven dispensing systems
            </h2>
            <p className="mt-5 leading-8 text-slate-600">
              Hydrotec Water ATM systems are designed to provide safe drinking
              water access with smart dispensing, digital payments, robust
              hardware, and remote monitoring capability.
            </p>
            <a
              href="https://www.arosia.in"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-block rounded-md bg-blue-600 px-4 py-2 text-sm font-medium text-white hover:bg-blue-700"
            >
              Know More
            </a>
          </div>

          <div className="rounded-3xl border border-slate-200 bg-white p-8 shadow-sm">
            <h3 className="text-xl font-semibold text-slate-900">Key Features</h3>
            <ul className="mt-5 space-y-3 text-slate-600">
              <li>• Smart dispensing interface</li>
              <li>• QR / digital payment integration</li>
              <li>• Durable outdoor kiosk design</li>
              <li>• Real-time usage and performance monitoring</li>
              <li>• Suitable for urban and rural deployments</li>
            </ul>
          </div>
        </div>
      </section>
    </>
  );
}